export const nestedFieldNameGeneratorFactory = (parentName) => {
  return (fieldName) => {
    return `${parentName}.${fieldName}`
  }
}
